import AppTools from '@/components/Layout/AppTools.tsx';
import { MenuLeft } from '@/components/Layout/MenuLeft.tsx';
import Logo from '@/components/Logo.tsx';
import { TutorialTour } from '@/features/Tutorial/TutorialTour.tsx';
import { Toaster } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router';

export const LEFT_MENU_WIDTH = 240;
export const TOPBAR_HEIGHT = 64;

/**
 * Main Layout
 *
 * @returns the PageMain component
 */
export const Layout = () => {
  return (
    <Box
      sx={{
        height: '100%', // Forwarding height 100% to children
      }}
    >
      <Stack
        direction={'row'}
        sx={(theme) => ({
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: theme.palette.background.sidenav,
          paddingLeft: 3,
          height: `${TOPBAR_HEIGHT}px`, // Height of the top bar
          position: 'fixed',
          width: 'stretch',
          top: 0,
          zIndex: 3,
        })}
      >
        <Logo />
        <AppTools />
      </Stack>
      <Stack
        direction={'row'}
        sx={{
          paddingTop: `${TOPBAR_HEIGHT}px`, // Height of the top bar
          height: '100%', // Forwarding height 100% to children
        }}
      >
        <Stack
          sx={(theme) => ({
            backgroundColor: theme.palette.background.sidenav,
            position: 'fixed',
            zIndex: 3,
            height: '100%',
            width: `${LEFT_MENU_WIDTH}px`, // Width of the left menu
          })}
        >
          <MenuLeft />
        </Stack>

        <Stack
          sx={{
            width: 'calc(100%)',
            height: '100%', // Forwarding height 100% to children
          }}
        >
          <Box
            sx={(theme) => ({
              height: '100%', // Forwarding height 100% to children
              paddingRight: 2,
              paddingTop: 2,
              paddingBottom: 2,
              paddingLeft: `calc(${LEFT_MENU_WIDTH}px + ${theme.spacing(2)})`,
              borderTop: `1px solid ${theme.palette.border.light}`,
            })}
          >
            <Toaster duration={10000} />
            <Outlet />
          </Box>
        </Stack>
      </Stack>
      <TutorialTour />
    </Box>
  );
};
